/** Default meta copy — tune for search & social previews */
export const SITE_NAME = 'The Functional Nurse Practitioner'

export const SEO = {
  home: {
    title: 'Functional medicine & personalized care',
    description:
      'Board-certified Family Nurse Practitioner in Indiana. Conventional and functional medicine for chronic disease, hormones, gut health, and root-cause care. Book a free consultation.',
  },
  about: {
    title: 'About',
    description:
      'Meet Tara Quintana, FNP: training, functional medicine background, The Functional Nurse Practitioner practice, and our holistic approach to care.',
  },
  wifm: {
    title: 'What is functional medicine?',
    description:
      'How functional medicine differs from conventional care for chronic illness: root-cause focus, personalized plans, and partnership in your health journey.',
  },
  membership: {
    title: 'Membership',
    description:
      'Why we use a membership model, what to expect from visits, and Basic, Platinum, and a la carte options for functional medicine care.',
  },
  podcast: {
    title: 'Podcast',
    description:
      'The Functional Nurse Practitioner podcast — evidence-based conversations on health and wellness. Listen on Spotify or Apple Podcasts.',
  },
  notFound: {
    title: 'Page not found',
    description: 'The page you requested could not be found.',
  },
}
